import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    window.addEventListener("trix-file-accept", function (event) {
      event.preventDefault();
      alert("No se puede subir archivos");
    });
  }
}
